import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfService} from '../../conf.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {DialogModelError} from '../../shared/dialog/dialog-error/model';
import {DialogErrorComponent} from '../../shared/dialog/dialog-error/dialog-error.component';
import {environment} from '../../../environments/environment';
import * as CryptoJS from 'crypto-js';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {ApiintegrationsListenerService} from '../../apiintegrations-listener.service';
import {DialogComponent} from '../../shared/dialog/dialog.component';
import {AccountInfoService} from '../../user/account-info.service';

declare let $;

@Component({
  selector: 'app-connectors',
  templateUrl: './connectors.component.html',
  styleUrls: ['./connectors.component.scss']
})
export class ConnectorsComponent implements OnInit {

  partner: string;
  account: string;
  producer: string;
  connectorsForProducer = {};
  connections: any;
  connectorsID: number;

  loading = false;
  isLoaded = true;
  selectedProducer: any;
  authorizationList = [];
  connectorLoader = false;
  loaderContent = '';
  selectedIndex = 1;
  authLength: any;
  constructor(private route: ActivatedRoute,
              private router: Router,
              private confPost: ConfService,
              private dialog: MatDialog,
              public accountInfoService: AccountInfoService,
              public platform: LeftpanelComponent,
              private integrationsListener: ApiintegrationsListenerService) { }

  ngOnInit() {
    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }
    this.route.queryParams
        .subscribe(params => {
          if (params) {
            if (params.code && params.state && params.code !== null && params.state !== null) {
              this.selectedIndex = 2;
              let index: number;
              const code = params.code;
              const state = params.state;
              const pkey = localStorage.getItem('partnerKey');
              const redirect_uri = environment.platformRedirectURL + '/connectors';
              Promise.resolve(this.getSelectedProducer(localStorage.getItem('producer'))).then(response1 => {
                this.confPost.getData('services', 'services', 'v1', 'apiconnectors', 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&producer=' + localStorage.getItem('producer')).subscribe(response => {
                  if (response[0]) {
                    this.connections = response[0]['connectors'];
                    this.connectorsID = response[0]['id'];
                    if (localStorage.getItem('connectorConfigurationMode') === 'add') {
                      if (this.connections) {
                        index = this.connections.length - 1;
                      } else {
                        index = 0;
                      }
                    }
                  } else {
                    index = 0;
                  }
                  this.confPost.getConnectorAccessToken(pkey, redirect_uri, code, state, index, this.selectedProducer['producer'], true).subscribe(response2 => {
                    this.isLoaded = false;
                    this.platform.openSnackBar('Connector Created successfully', 'Success', {
                      duration: 3000,
                      verticalPosition: 'top',
                      horizontalPosition: 'center'
                    });
                    this.isLoaded = true;
                    this.confPost.getData('services', 'services', 'v1', 'apiconnectors', 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&producer=' + localStorage.getItem('producer')).subscribe(response => {
                      this.connections = response[0]['connectors'];
                      this.connectorsID = response[0]['id'];
                      this.isLoaded = false;
                      this.router.navigate(['/connectors'], { queryParams: { partner: localStorage.getItem('partner'), account: localStorage.getItem('account'), producer: localStorage.getItem('producer')} });
                    });
                  }, error => {
                    this.platform.openSnackBar('Error in creating connector', 'Error', {
                      duration: 3000,
                      verticalPosition: 'top',
                      horizontalPosition: 'center'
                    });
                  });
                });
              });
            }
            if (params.partner && params.account && params.producer && params.partner !== null && params.account !== null && params.producer !== null) {
              this.partner = params.partner;
              this.account = params.account;
              this.producer = params.producer;
              localStorage.setItem('producer', params.producer);
              Promise.resolve(this.getSelectedProducer(params.producer)).then(response1 => {
                this.confPost.getData('services', 'services', 'v1', 'apiconnectors', 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&producer=' + localStorage.getItem('producer')).subscribe(response => {
                  if (response[0]) {
                    this.connections = response[0]['connectors'];
                    this.connectorsID = response[0]['id'];
                    this.isLoaded = false;
                    if (localStorage.getItem('connectorConfigurationMode') === 'add') {
                      // index = 0;
                      if (this.connections && this.connections.length === 0) {
                        // index = 0;
                      } else {
                        for (const connector of this.connections) {
                          if (connector['service'] === localStorage.getItem('selectedConnector')) {
                            // index = connector['connections'].length;
                          }
                        }
                      }
                      // this.confPost.getConnectorAccessToken(pkey, redirect_uri, code, state, index, localStorage.getItem('selectedConnector')).subscribe(response1 => {
                      // });
                    }
                  } else {
                    this.isLoaded = false;
                  }
                  this.confPost.getDataWithQuery('services', 'services', 'v1', 'apiproducers', 'producer=' + this.producer).subscribe(res =>
                  {
                    this.authLength = res[0]['authorization'].length;
                  });
                });
              });
              // this.connectorsForProducer['partner'] = 'services';
              // this.connectorsForProducer['account'] = 'services';
              // this.connectorsForProducer['version'] = 'v1';
              // this.connectorsForProducer['sourcetype'] = 'entity';
              // this.connectorsForProducer['entity'] = 'apiconnectors';
              // this.connectorsForProducer['condition'] = 'partner=' + this.partner + '&account=' + this.account;

              // this.confPost.getData('services', 'services', 'v1', 'apiconnectors', 'partner=' + this.partner + '&account=' + this.account).subscribe(response => {
              //   this.connectorsForProducer['data'] = response;
              // });
              this.selectedIndex = 1;
            } if (params.selected !== null && params.selected !== undefined) {
              this.selectedIndex = 2;
            }
          }
        });
  }
  toUpper(val) {
    return val.toUpperCase();
  }
  stringifyjson(val) {
    return JSON.stringify(val);
  }
  testConnection(index, id) {
    Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'serviceprovider_connector_test_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response1 => {
      const payloadToSend = {
        actions: response1
      };
      this.integrationsListener.apiIntegraionsListener.emit({
        type: 'audit',
        id: localStorage.getItem('IdOfSession'),
        payload: payloadToSend
      });
    });
    this.connectorLoader = true;
    this.loaderContent = 'Connecting...';
    this.confPost.testConnectorConnection(localStorage.getItem('partnerKey'), index, this.selectedProducer['producer']).subscribe(response => {
      Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'serviceprovider_connector_test_success', 'INFO', response.status, response.statusText, '', {index: index, payload: this.selectedProducer['producer']}, response, this.router.url)).then(response1 => {
        const payloadToSend = {
          actions: response1
        };
        this.integrationsListener.apiIntegraionsListener.emit({
          type: 'audit',
          id: localStorage.getItem('IdOfSession'),
          payload: payloadToSend
        });
      });
      this.platform.openSnackBar('Connection is successfully established', 'Success', {
        duration: 3000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      this.connectorLoader = false;
      Promise.resolve(this.getSelectedProducer(this.producer)).then(response1 => {
        this.confPost.getData('services', 'services', 'v1', 'apiconnectors', '?partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&producer=' + localStorage.getItem('producer')).subscribe(response12 => {
          if (response12[0]) {
            this.connections = response12[0]['connectors'];
            this.connectorsID = response12[0]['id'];
            this.isLoaded = false;
            if (localStorage.getItem('connectorConfigurationMode') === 'add') {
              // index = 0;
              if (this.connections && this.connections.length === 0) {
                // index = 0;
              } else {
                for (const connector of this.connections) {
                  if (connector['service'] === localStorage.getItem('selectedConnector')) {
                    // index = connector['connections'].length;
                  }
                }
              }
              // this.confPost.getConnectorAccessToken(pkey, redirect_uri, code, state, index, localStorage.getItem('selectedConnector')).subscribe(response1 => {
              // });
            }
          } else {
            this.isLoaded = false;
          }
          this.confPost.getDataWithQuery('services', 'services', 'v1', 'apiproducers', 'producer=' + this.producer).subscribe(res =>
          {
            this.authLength = res[0]['authorization'].length;
          });
        });
      });
    }, error => {
      let errorMessage = '';
      if (error.error['message']) {
        errorMessage = error.error.message;
      } else {
        errorMessage = error.error;
      }
      Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'serviceprovider_connector_test_failed', 'ERROR', error.status, error.statusText, errorMessage, {index: index, payload: this.selectedProducer['producer']}, error, this.router.url)).then(response4 => {
        const payloadToSend = {
          actions: response4
        };
        this.integrationsListener.apiIntegraionsListener.emit({
          type: 'audit',
          id: localStorage.getItem('IdOfSession'),
          payload: payloadToSend
        });
      });
      this.platform.openSnackBar('Invalid Connection', 'Error', {
        duration: 3000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      this.connectorLoader = false;
    });
  }

  deleteConnection(index) {
    if (confirm('Are you sure you want to delete the connection?')) {
      Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'serviceprovider_connector_delete_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response1 => {
        const payloadToSend = {
          actions: response1
        };
        this.integrationsListener.apiIntegraionsListener.emit({
          type: 'audit',
          id: localStorage.getItem('IdOfSession'),
          payload: payloadToSend
        });
      });
      this.connectorLoader = true;
      this.loaderContent = 'Deleting...';
      this.confPost.deleteConnectorConnection(localStorage.getItem('partnerKey'), index, this.selectedProducer['producer']).subscribe(response => {
        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'serviceprovider_connector_delete_success', 'INFO', response.status, response.statusText, '', {index: index, payload: this.selectedProducer['producer']}, response, this.router.url)).then(response1 => {
          const payloadToSend = {
            actions: response1
          };
          this.integrationsListener.apiIntegraionsListener.emit({
            type: 'audit',
            id: localStorage.getItem('IdOfSession'),
            payload: payloadToSend
          });
        });
        this.platform.openSnackBar('Connector deleted successfully', 'Success', {
          duration: 3000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        // window.location.reload();
        this.connectorLoader = false;
        this.refreshConnectors();
      }, error => {
        let errorMessage = '';
        if (error.error['message']) {
          errorMessage = error.error.message;
        } else {
          errorMessage = error.error;
        }
        Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'serviceprovider_connector_delete_failed', 'ERROR', error.status, error.statusText, errorMessage, {index: index, payload: this.selectedProducer['producer']}, error, this.router.url)).then(response4 => {
          const payloadToSend = {
            actions: response4
          };
          this.integrationsListener.apiIntegraionsListener.emit({
            type: 'audit',
            id: localStorage.getItem('IdOfSession'),
            payload: payloadToSend
          });
        });
        this.platform.openSnackBar('Error in deleting connector. Please try again afer sometime', 'Error', {
          duration: 3000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        this.connectorLoader = false;
      });
    }
  }

  getSelectedProducer(producerName) {
    return new Promise((resolve, reject) => {
      this.confPost.getData('services', 'services', 'v1', 'apiproducers', null).subscribe(response => {
        const temp = [];
        const iterator = response[Symbol.iterator]();
        while (true) {
          const tempObject = iterator.next();
          if (tempObject.done) {
            break;
          }
          temp.push(tempObject.value);
        }
        for (const producer of temp) {
          if (producer['producer'] === producerName) {
            this.selectedProducer = producer;
          }
        }
        resolve(this.selectedProducer);
      });
    });
  }

  configureConnector(mode) {
    localStorage.setItem('connectorConfigurationMode', mode);
    if (this.connections === null || this.connections === undefined) {
      this.connections = [];
    }
    const payload = {
      connector: this.selectedProducer,
      connections: this.connections,
      connectorsID: this.connectorsID
    };
    const dialogRef = this.dialog.open(GetConnectorConfigurationsComponent, {
      data: payload,
      width: '400px'
    });

    dialogRef.afterClosed().subscribe(result => {
      this.refreshConnectors();
    });
  }

  refreshConnectors() {
    this.confPost.getData('services', 'services', 'v1', 'apiconnectors', 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&producer=' + localStorage.getItem('producer')).subscribe(response => {
      if (response[0]) {
        this.connections = response[0]['connectors'];
        this.connectorsID = response[0]['id'];
      }
    });
  }

  getPassword(connection) {
    const dialogRef = this.dialog.open(GetPasswordComponent, {
      data: connection,
      width: '400px'
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
}

@Component({
  selector: 'configure-connector',
  templateUrl: 'get-connector-configurations.component.html',
  styleUrls: ['get-connector-configurations.component.css']
})
export class GetConnectorConfigurationsComponent implements OnInit {

  payload = {};
  connectorName: any;
  loading = false;
  authorizationList = [];
  authorizationConfigurations: any;
  authorizationType: string;

  additionalConfigurations = [];
  producerData: any;

  platformRedirectURL = environment.platformRedirectURL;

  constructor(
      public dialogRef: MatDialogRef<GetConnectorConfigurationsComponent>,
      private confPost: ConfService,
      private dialog: MatDialog, public platform: LeftpanelComponent, private integrationsListener: ApiintegrationsListenerService, private router: Router,
      @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    this.confPost.getData('services', 'services', 'v1', 'authorizationConfigurations', null).subscribe(response => {
      const temp = [];
      const iterator = response[Symbol.iterator]();
      while (true) {
        const tempObject = iterator.next();
        if (tempObject.done) {
          break;
        }
        temp.push(tempObject.value);
      }
      for (const authorization of temp) {
        this.authorizationList.push(authorization['authType']);
      }
    });
    this.confPost.getData('services', 'services', 'v1', 'apiproducers', 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&producer=' + this.data['connector']['producer']).subscribe(res => {
      this.producerData = res;
    });
  }
  stringifyjson(val) {
    return JSON.stringify(val);
  }
  addNewConfiguration() {
    const dialogRef = this.dialog.open(AddNewAuthorizationConfigurationComponent, {
      width: '380px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.additionalConfigurations.push(result);
      }
    });
  }

  getSelectedAuthAttributes() {
    // if(confirm('Changing the authorization type will remove all the configurations that you have provided so far. Do you still wish to continue?')) {
    this.additionalConfigurations = [];
    // this.confPost.getData('services', 'services', 'v1', 'authorizationConfigurations', 'authType=' + encodeURIComponent(this.authorizationType)).subscribe(response => {
    //   this.authorizationConfigurations = response[0]['authAttributes'];
    //   if ( this.authorizationType === 'OAuth 2.0') {
    //       if ( this.producerData !== undefined && this.producerData !== null) {
    //           this.payload['refreshtoken_url'] = this.producerData[0]['oauth2attributes']['refreshtoken_url'];
    //           this.payload['base_url'] = this.producerData[0]['oauth2attributes']['base_url'];
    //           this.payload['token_url'] = this.producerData[0]['oauth2attributes']['token_url'];
    //       }
    //   }
    // });
    this.payload = {};
    this.authorizationConfigurations = this.authorizationType['authattributes'];
    for (let i = 0; i < this.authorizationConfigurations.length; i++ ){
      this.payload[this.authorizationConfigurations[i]['key']] = this.authorizationConfigurations[i]['value']
    }
    // }
  }

  close() {
    this.dialogRef.close();
  }

  removeAdditionalConfiguration(index) {
    this.additionalConfigurations.splice(index, 1);
  }

  patchConnectors(id, payload) {
    return new Promise((resolve, reject) => {
      this.confPost.patchEntityData('services', 'services', 'v1', 'apiconnectors', id, payload).subscribe(response => {
        resolve('success');
      }, error => {
        resolve('failed');
      });
    });
  }

  async verifyConfigurations() {
    // let i = this.data.connections.length;
    // while (i--) {
    //   if (this.data.connections[i] && this.data.connections[i].hasOwnProperty('status') && (this.data.connections[i]['status'] === false || this.data.connections[i]['status'] === 'false')) {
    //     this.data.connections.splice(i, 1);
    //   }
    // }

    const trueFiltered = this.data.connections.filter(function(value, index, arr){
      return value['status'] === true;
    });

    await this.patchConnectors(this.data.connectorsID, {connectors: trueFiltered});

    if (trueFiltered.filter(connector => connector['name'] === this.connectorName).length === 0) {
      this.loading = true;
      let isValid: boolean;
      if (this.authorizationConfigurations) {
        for (let i = 0; i < this.authorizationConfigurations.length; i++) {
          if (!this.payload[this.authorizationConfigurations[i]['key']]) {
            isValid = false;
            break;
          } else {
            isValid = true;
          }
        }
      } else {
        isValid = false;
      }
      if (this.connectorName !== null && this.connectorName !== undefined && this.authorizationType !== null && this.authorizationType !== undefined && isValid) {
        let redirectString = environment.pythonServicesServer + '/v1/' + localStorage.getItem('partner') + '/' + localStorage.getItem('account') + '/' + this.data['connector']['producer'] + '/authrequest?pkey=' + localStorage.getItem('partnerKey') + '&redirect_uri=' + environment.platformRedirectURL + '/connectors&status=false';
        for (const configuration of this.authorizationConfigurations) {
          redirectString = redirectString + '&' + configuration['key'] + '=' + this.payload[configuration['key']];
        }
        if (this.additionalConfigurations.length > 0) {
          for (const configuration of this.additionalConfigurations) {
            redirectString = redirectString + '&' + configuration['key'] + '=' + configuration['value'];
          }
        }
        redirectString = redirectString + '&name=' + this.connectorName + '&authType=' + this.authorizationType['authtype'];
        if (this.authorizationType['authtype'].includes('OAuth 2.0')) {
          window.location.href = redirectString;
        } else {
          this.confPost.authRequest(redirectString).subscribe(response => {
            Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'serviceprovider_connector_create_success', 'INFO', 200, 'OK', '', redirectString, response, this.router.url)).then(response1 => {
              const payloadToSend = {
                actions: response1
              };
              this.integrationsListener.apiIntegraionsListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
              });
            });
            this.loading = false;
            this.platform.openSnackBar('Connector has been created successfully', 'Success', {
              duration: 2000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
            if(!this.data.redirect) {
              this.dialogRef.close();
            } else {
            this.dialogRef.close();
              this.router.navigateByUrl('/connectors?partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&producer=' + this.data.connector.producer + '&selected=2');
            }
            // window.location.reload();
          }, error => {
            let errorMessage = '';
            if (error.error['message']) {
              errorMessage = error.error.message;
            } else {
              errorMessage = error.error;
            }
            Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'serviceprovider_connector_create_failed', 'ERROR', error.status, error.statusText, errorMessage, redirectString, error, this.router.url)).then(response4 => {
              const payloadToSend = {
                actions: response4
              };
              this.integrationsListener.apiIntegraionsListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
              });
            });
            this.platform.openSnackBar('Error in creating connector. Please try again after sometime', 'Error', {
              duration: 2000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
          });
        }

      } else {
        alert('Please make sure you have provided all the values');
        this.loading = false;
      }
    } else {
      alert('Connector with the name already exists.');
      this.loading = false;
    }
  }
}

@Component({
  selector: 'get-password',
  templateUrl: 'get-password.component.html',
  styleUrls: ['get-password.component.css']
})
export class GetPasswordComponent implements OnInit {

  password: any;
  connectorName: any;
  domainPartner: string;
  loaderflag = false;
  constructor(
      public platform: LeftpanelComponent,
      public dialogRef: MatDialogRef<GetPasswordComponent>,
      private confPost: ConfService,
      private dialog: MatDialog,
      @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    this.domainPartner = localStorage.getItem('partner');
  }
  close () {
    this.dialogRef.close();
  }

  encrypt (salt, iv, passPhrase, plainText, keySize, iterationCount) {
    const key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), { keySize: keySize, iterations: iterationCount });
    const encrypted = CryptoJS.AES.encrypt(
        plainText,
        key,
        { iv: CryptoJS.enc.Hex.parse(iv) });
    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  }


    verifyPassword() {
        if (this.password) {
            this.loaderflag = true;
            this.confPost.getPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(response => {
                const iterationCount = 1000;
                let keySize = 128;
                keySize = keySize / 32;
                const passphrase = environment.cipheringPhrase;

                const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
                const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
                const cipherText = this.encrypt(salt, iv, passphrase, this.password, keySize, iterationCount);
                const loginPayload = {
                    emailId: localStorage.getItem('signInEmail'),
                    environment: this.domainPartner,
                    password: cipherText,
                    shash: salt,
                    ralam: iv
                };
                this.confPost.validateLogin(loginPayload).subscribe(data => {
                    if (data.status === 200) {
                        if (data.body != null) {
                            this.dialogRef.close();
                            this.showCredentials(this.data);
                        } else {
                            alert('Incorrect Password');
                            this.loaderflag = false;
                        }
                    } else {
                        this.loaderflag = false;
                    }
                }, error => {
                    if (error.status === 401) {
                        this.platform.openSnackBar('Please enter a valid password', 'Error', {
                            duration: 3000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    } else {
                        this.platform.openSnackBar(error.error ? error.error : 'Please enter a valid password', 'Error', {
                            duration: 3000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                    this.loaderflag = false;
                });
            });
        }
    }

  showCredentials(connection) {
    const dialogRef = this.dialog.open(ShowCredentialsComponent, {
      data: connection,
      width: '50%'
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
}

@Component({
  selector: 'show-credentials',
  templateUrl: 'show-credentials.component.html',
  styleUrls: ['show-credentials.component.css']
})
export class ShowCredentialsComponent implements OnInit {

  password: any;
  connectorName: any;

  constructor(
      public platform: LeftpanelComponent,
      public dialogRef: MatDialogRef<ShowCredentialsComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  closeDialog() {
    this.dialogRef.close();
  }

  ngOnInit() {
  }
  stringifyjson(val) {
    return JSON.stringify(val);
  }

}

@Component({
  selector: 'app-addnewauthorizationconfiguration',
  templateUrl: 'add-new-authorization-configuration.component.html',
  styleUrls: ['add-new-authorization-configuration.component.css']
})
export class AddNewAuthorizationConfigurationComponent implements OnInit {

  payload = {
    key: '',
    value: ''
  };

  constructor(
      public platform: LeftpanelComponent,
      public dialogRef: MatDialogRef<AddNewAuthorizationConfigurationComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  closeDialog() {
    this.dialogRef.close();
  }

  addToConfiguration() {
    if (this.payload.key !== '' && this.payload.value !== '') {
      this.dialogRef.close(this.payload);
    } else {
      alert('Please provide a valid key value pair');
    }
  }

  ngOnInit() {
  }

}
